import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import teamIcon from "../../Assets/Teams/team.png"
import { useTranslation } from "react-i18next";
import { onboardTeamMember } from "../../Requests/TeamRequests";
import { getTeamUuid } from "../../utils/cookies";
import { CopyToClipboard } from "react-copy-to-clipboard";

export default function NewTeamMemberModal({ handleClose }) {
    const [open, setOpen] = useState(true);
    const navigate = useNavigate();
    const { t } = useTranslation()
    const [step, setStep] = useState(0)
    const [inviteLink, setInviteLink] = useState(null)
    const closeModal = () => {
        handleClose()
        setOpen(false)
    }

    const createTeamMember = (event) => {
        event.preventDefault()
        let data = { "email": event.target.email.value, "team_uuid": getTeamUuid() }

        onboardTeamMember(data).then((res) => {
            setInviteLink(res.data.token)
            setStep(1)
        }).catch((e) => {

        })
    }

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={() => closeModal()}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                <Dialog.Title
                                    as="h3"
                                    className="text-lg font-medium leading-6 text-gray-900 text-center"
                                >
                                    {t('Team.NewTeamMemberModal.Title')}
                                </Dialog.Title>
                                <div className="py-4">
                                    <div className="mx-auto flex h-64 w-64 items-center justify-center rounded-full ">
                                        <img src={teamIcon} />
                                    </div>
                                    <div className="mt-3 text-center sm:mt-5">

                                        {step == 0 ? <div className="mt-2">
                                            <p className="text-sm text-gray-500">
                                                {t('Team.NewTeamMemberModal.Description')}
                                            </p>
                                        </div> :
                                            <div className="text-center text-sm font-bold">{t('Team.NewTeamMemberModal.NewTeamMemberAddedLabel')}</div>}
                                    </div>
                                </div>
                                {step == 0 &&
                                    <form onSubmit={createTeamMember}>
                                        <div className='flex gap-2 w-full  flex-col mt-4 items-center justify-center'>
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                className="block max-w-md w-full text-center rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                                                placeholder={t('Team.NewTeamMemberModal.Placeholder')}
                                            >
                                            </input>
                                            <button
                                                className='bg-black text-white rounded-md px-12 py-2 w-fit'>
                                                {t('Team.NewTeamMemberModal.ButtonText')}
                                            </button>
                                        </div>
                                    </form>
                                }
                                {step == 1 &&
                                    <div>
                                        <div className="text-sm border overflow-x-scroll rounded-md px-4 py-2">{inviteLink}</div>
                                        <div className="mt-4 flex justify-between">
                                            <CopyToClipboard text={inviteLink}>
                                                <button className="border-2 border-black bg-black text-white rounded-md px-4 py-2 text-sm hover:bg-white hover:text-black">
                                                    {t('Team.NewTeamMemberModal.CopyLinkLabel')}
                                                </button>
                                            </CopyToClipboard>
                                            <button
                                                onClick={() => {
                                                    window.location.reload(false)
                                                }}
                                                className="border-2 border-black bg-white text-black rounded-md px-4 py-2 text-sm hover:bg-black hover:text-white">
                                                {t('Team.NewTeamMemberModal.CloseLabel')}
                                            </button>
                                        </div>
                                    </div>
                                }
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root >
    );
}
